// Look at https://github.com/mui-org/material-ui/blob/v0.19.4/src/styles/getMuiTheme.js
// for a full spec of possibilities.

import _colors from './core/modules/common/colors';

export default {
  palette: {
    textColor: '#575858',
  },
  menuItem: {
    selectedTextColor: '#0099cc',
  },
  checkbox: {
    label: {
      color: '#575858',
    },
    checkbox: {
      color: '#b9b9b9',
    },
    states: {
      active: {
        label: {
          color: '#0099cc',
        },
        checkbox: {
          fill: '#0099cc',
        },
      },
    },
  },
  selectDropDown: {
    style: {
      fontSize: '14px',
    },
    menuItem: {
      color: '#575858',
    },
    selectedMenuItem: {},
  },
  redButton: {
    backgroundColor: _colors.backgroundColorTertiary,
    borderColor: _colors.backgroundColorTertiary,
    color: _colors.colorWhite,
    disabled: {
      backgroundColor: _colors.colorLightRed,
      borderColor: _colors.colorLightRed,
      color: _colors.colorWhite,
    },
  },
  blueButton: {
    backgroundColor: _colors.colorLightBlue,
    borderColor: _colors.colorLightBlue,
    color: _colors.colorWhite,
    lineHeight: '25px',
    disabled: {
      backgroundColor: _colors.backgroundColorDefault,
      borderColor: _colors.backgroundColorDefault,
      color: _colors.colorBlueNavy,
      lineHeight: '25px',
    },
  },
  keepState: {
    backgroundColor: _colors.colorLightBlue,
    color: _colors.colorWhite,
    borderColor: _colors.colorLightBlue,
  },
  showOnlySelected: {
    style: {
      display: 'inline-block',
      top: '4px',
      width: '165px',
    },
    labelStyle: {
      color: _colors.colorLightBlue,
      width: '100%',
    },
    iconStyle: {
      fill: _colors.colorLightBlue,
      marginRight: '6px',
    },
  },
  operatorSelectors: {
    button: { style: { float: 'right' } },
  },
};
